
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import IconPicker from './IconPicker';

import { Button, Modal, Box, Card, CardContent, Avatar, TextField, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
};

const Profile = () => {
    const { auth, setAuth } = useContext(AuthContext);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [formData, setFormData] = useState({
        username: auth.user?.username || '',
        email: auth.user?.email || '',
        password: '',
        icon: auth.user?.icon || 'Person',
    });

    useEffect(() => {
        if (auth.user) {
            setFormData({
                username: auth.user.username,
                email: auth.user.email,
                password: '',
                icon: auth.user.icon,
            });
        }
    }, [auth.user]);

    const { username, email, password, icon } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onIconChange = icon => {
        console.log(icon);
        setFormData({ ...formData, icon });
    };

    const onSubmit = async e => {
        e.preventDefault();
        console.log(formData);
        try {
            const res = await axios.put(`/api/users/${auth.user.id}`, formData);
            setAuth({ ...auth, user: res.data });
            navigate('/');
            console.log(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Card sx={{ maxWidth: 600, margin: 'auto', mt: 5 }}>
            <CardContent>
                <h1>Страница профиля</h1>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                    <Avatar sx={{ width: 56, height: 56 }}>
                        {icon}
                    </Avatar>
                </Box>
                <Box component="form" onSubmit={onSubmit} sx={{ mt: 1 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                sx={{ width: 270 }}
                                required
                                fullWidth
                                id="username"
                                label="Имя пользователя"
                                name="username"
                                autoComplete="username"
                                value={username}
                                onChange={onChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                sx={{ width: 270 }}
                                required
                                fullWidth
                                id="email"
                                label="Email"
                                name="email"
                                autoComplete="email"
                                value={email}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                sx={{ width: 270 }}
                                fullWidth
                                name="password"
                                label="Новый пароль"
                                type="password"
                                id="password"
                                autoComplete="new-password"
                                value={password}
                                onChange={onChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <TextField
                                sx={{ width: 270 }}
                                required
                                label="Выбранная иконка"
                                value={icon}
                                InputProps={{
                                    readOnly: true,
                                    startAdornment: (
                                        <Avatar sx={{ width: 20, height: 20, mr: 1 }}>
                                            {icon}
                                        </Avatar>
                                    ),
                                    endAdornment: (
                                        <Button onClick={handleOpen} size="small">Выбрать иконку</Button>
                                    ),
                                }}
                            />
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={style}>
                                    <IconPicker
                                        onChange={onIconChange}
                                        onClose={handleClose}
                                    />
                                </Box>
                            </Modal>
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Обновить профиль
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default Profile;
